import { Injectable } from '@angular/core';
import { IObservation } from '../../message-models/observation.interface';
import { Observation, ObservationType } from '../../domain-model/observation.class';
import { CreateOrEditObservationModalComponent } from '../components/create-or-edit-observation-modal/create-or-edit-observation-modal.component';
import { Observable, of } from 'rxjs';
import { EcaModalOptions } from '../../shared/models/yesno-modal-options.class';
import { IModalOptions } from '../../common/modals/modal-options.interface';
import { EcaDynamicModalService } from "../../shared/services/eca-dynamic-modal-service";
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { IEcaDialogRef } from '../../shared/models/eca-dialog-ref.interface';

@Injectable({
  providedIn: 'root'
})

export class ObservationModalService {
  observationModalRef: IEcaDialogRef;

  constructor(private ecaDynamicModalService: EcaDynamicModalService) { }

  createOrEditObservation(observation?: IObservation,
    heading?: string,
    isEditing?: boolean,
    observationType?: ObservationType,
    showSaveAndUploadButton?: boolean,
    options?: IModalOptions
    ): Observable<IEcaDialogRef> {
    if (this.observationModalRef) {
      this.observationModalRef.dynamicDialogRef.close();
    }
    if (options === undefined) {
      options = new EcaModalOptions();
      options.modalClasses += " modal-eca-success";
    }
    if (!observation) {
      observation = new Observation({} as IObservation);
      observation.observationType = observationType;
    }

    let config = {
      styleClass: 'modal-xl ' + options.modalClasses,
      baseZIndex: 2000,
      showHeader: false,
      data: {
        observation: observation,
        modalHeading: heading,
        isEditing: isEditing,
        showSaveAndUploadButton: showSaveAndUploadButton
      }
    } as DynamicDialogConfig;

    this.observationModalRef = this.ecaDynamicModalService.openDialog(CreateOrEditObservationModalComponent, config);
    return of(this.observationModalRef);
  }
}
